
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { StepItemProps } from ".";
import { loading, update } from "store/step";
import { AppMessage } from "components";

interface ApiStepUpdateInputProps extends StepItemProps {
}

type ApiStepUpdateOutputProps = OutputBaseProps<{ item: StepItemProps; }, ApiStepUpdateInputProps>

export const apiStepUpdate = async (data: ApiStepUpdateInputProps, workflowId: number) => {
    store.dispatch(loading());
    const res = (await axios.put<ApiStepUpdateOutputProps>(`/api/workflow/${workflowId}/step/update`, data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(update({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};